import { render, staticRenderFns } from "./FAQHighestSpreadsComponent.vue?vue&type=template&id=9f58234c&scoped=true&"
import script from "./FAQHighestSpreadsComponent.vue?vue&type=script&lang=ts&"
export * from "./FAQHighestSpreadsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FAQHighestSpreadsComponent.vue?vue&type=style&index=0&id=9f58234c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f58234c",
  null
  
)

export default component.exports